export default "__VITE_ASSET__I9xQ4Dh2__"